import { render } from "./ClickBankProductRow.vue?vue&type=template&id=f1bf3fb8"
import script from "./ClickBankProductRow.vue?vue&type=script&lang=js"
export * from "./ClickBankProductRow.vue?vue&type=script&lang=js"
script.render = render

export default script